import styled from 'styled-components'

import { LinkBase } from './link'

export const LinkContainer = styled(LinkBase)`
    color: inherit;
`
